import { useState } from "react";
import { hotTopics, editorNote } from "@/mocks/home";

export default function SideRail() {
  const [notice, setNotice] = useState("");

  return (
    <aside className="flex flex-col gap-6">
      {/* hot topics */}
      <div className="rounded-lg border border-background-300 bg-background-100 p-5">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-hashtag text-primary-600" aria-hidden="true"></i>
          <h3 className="font-heading text-base font-bold text-foreground-950">热议话题</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {hotTopics.map((topic) => (
            <a
              key={topic}
              href="#today"
              className="px-2.5 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label hover:bg-secondary-200 transition-colors"
            >
              {topic}
            </a>
          ))}
        </div>
      </div>

      {/* editor note */}
      <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
        <div className="flex items-center gap-2 mb-3">
          <i className="ri-information-line text-accent-700" aria-hidden="true"></i>
          <h3 className="font-heading text-base font-bold text-foreground-950">{editorNote.title}</h3>
        </div>
        <p className="text-sm leading-6 text-foreground-700">{editorNote.body}</p>
      </div>

      {/* subscribe reminder (visual only) */}
      <div className="rounded-lg border border-background-300 bg-background-50 p-5">
        <div className="flex items-center gap-2 mb-2">
          <i className="ri-notification-3-line text-primary-600" aria-hidden="true"></i>
          <h3 className="font-heading text-base font-bold text-foreground-950">新瓜提醒</h3>
        </div>
        <p className="text-xs leading-6 text-foreground-500 mb-3">
          留下邮箱，重要爆料更新时第一时间提醒你。（演示功能，不会真实发送）
        </p>
        <div className="flex flex-col sm:flex-row gap-2">
          <input
            type="text"
            value={notice}
            onChange={(e) => setNotice(e.target.value)}
            placeholder="you@example.com"
            className="flex-1 h-10 px-3 rounded-md border border-background-300 bg-background-50 text-sm outline-none focus:border-primary-300 placeholder:text-foreground-400"
          />
          <button
            type="button"
            onClick={() => setNotice("")}
            className="h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            订阅
          </button>
        </div>
        <p className="mt-2 text-[11px] text-foreground-400">点击订阅仅作页面演示，不会提交任何数据。</p>
      </div>
    </aside>
  );
}